import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  padding: 16px 16px 0px 16px;
`;

const Img = styled.img`
  margin: 0 auto;
  width: 475px;
  height: 173px;
  @media (max-width: 768px) {
    width: 95%;
  }
`;

const Logo: React.SFC = () => {
  return (
    <Container>
      <Img
        src={process.env.PUBLIC_URL + '/assets/logos/logo.png'}
        alt='Sloan Longway logo'
      />
    </Container>
  );
};

export default Logo;
